import { getLinks, AcceptedLinksStarts } from '@cinch-nx/data-storyblok'
import { GetStaticPathsResult } from 'next'
import { storyblokLinkToPath } from './data/seo-page-data'

export const getStaticPathsGenerator =
  (slug: string) => async (): Promise<GetStaticPathsResult> => {
    try {
      const links = await getLinks(slug as AcceptedLinksStarts)
      const paths = storyblokLinkToPath({
        links,
      })

      return { paths, fallback: 'blocking' }
    } catch {
      return { paths: [], fallback: 'blocking' }
    }
  }
